import styled from 'styled-components';

import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { ActivitySettingsCheckpoint } from './activity.style';

export const ActivitySettingsControlWrapper = styled.div`
  position: relative;
`;

export const ActivitySettingsControl = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(40)};
  gap: ${rem(spacing8)};
  padding: ${rem(spacing8)};
`;

type ActivitySettingsControlCheckpointProps = {
  $isActive?: boolean;
};
export const ActivitySettingsControlCheckpoint = styled(
  ActivitySettingsCheckpoint
)<ActivitySettingsControlCheckpointProps>`
  position: absolute;
  right: -${rem(spacing8)};
  top: -${rem(spacing8)};
`;
